/* eslint-disable react-hooks/exhaustive-deps */
import { Drawer } from '@/components';
import { useEffect, useRef } from 'react';
import { useResponsive } from '@/hooks';
import { useDemo1Layout } from '../';
import { SidebarContent, SidebarHeader } from './';
import clsx from 'clsx';
import { usePathname } from '@/providers';

interface SidebarOptions {
  theme: string; // 'light' or 'dark'
}

interface LayoutOptions {
  sidebar: SidebarOptions;
}

interface Layout {
  options: LayoutOptions;
}

interface Demo1LayoutContext {
  layout: Layout;
  setSidebarCollapse: (value: boolean) => void;
}

const Sidebar = () => {
  const selfRef = useRef<HTMLDivElement>(null);
  const { pathname, prevPathname } = usePathname();

  const desktopMode = useResponsive('up', 'lg');
  const { mobileSidebarOpen, setSidebarMouseLeave, setMobileSidebarOpen } =
    useDemo1Layout();
  const { layout } = useDemo1Layout() as unknown as Demo1LayoutContext;
  const themeClass: string =
    layout.options.sidebar.theme === 'dark' || pathname === '/dark-sidebar'
      ? 'dark [&.dark]:bg-coal-600'
      : 'dark:bg-coal-600';

  const handleMobileSidebarClose = () => {
    setMobileSidebarOpen(false);
  };

  const handleMouseEnter = () => {
    setSidebarMouseLeave(false);
  };

  const handleMouseLeave = () => {
    setSidebarMouseLeave(true);
  };

  const renderContent = () => {
    return (
      <nav
        ref={selfRef}
        onMouseLeave={handleMouseLeave}
        onMouseEnter={handleMouseEnter}
        className={clsx(
          'sidebar bg-light border-e border-e-gray-200 dark:border-e-coal-100 z-[100] flex flex-col items-stretch shrink-0',
          desktopMode
            ? 'fixed top-0 bottom-0 lg:flex'
            : 'relative h-full w-[280px] max-w-[80vw]',
          themeClass
        )}
        aria-label="Main navigation"
      >
        {desktopMode && <SidebarHeader />}
        <SidebarContent />
      </nav>
    );
  };

  useEffect(() => {
    // Hide drawer on route chnage after menu link click
    if (!desktopMode && prevPathname !== pathname) {
      handleMobileSidebarClose();
    }
  }, [desktopMode, pathname, prevPathname]);

  if (desktopMode) {
    return renderContent();
  } else {
    return (
      <Drawer
        open={mobileSidebarOpen}
        onClose={handleMobileSidebarClose}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {renderContent()}
      </Drawer>
    );
  }
};

export { Sidebar };
